import React from "react";

const CurrentProjectContext = React.createContext({
  project: "",
  setProject: () => {}
});

export default CurrentProjectContext;